import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { setCallTimelineFilters } from 'store/actions/conferenceCall'
import { selectCallTimelineFilters } from 'store/selectors'
import { Link } from 'features/i18n/router'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { MODAL_MODE } from '../../config'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

const FilterCallCategory = ({ callTimelineMode }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { generatePageModalUrl } = usePageModal()

  const callTimelineFilters = useSelector(selectCallTimelineFilters)

  return (
    <div className="FilterCallCategory">
      <header>
        <b>{t('call_search_screen.title')}</b>
      </header>

      {callTimelineFilters?.category?.id && (
        <main>
          <ImageLoader url={callTimelineFilters?.category.icon_url} />
          <b>{callTimelineFilters?.category.title}</b>
          <a onClick={() => dispatch(setCallTimelineFilters('category'))}>
            <img src="/images/icon-close-sq.svg" />
          </a>
        </main>
      )}

      <footer>
        <Link
          to={generatePageModalUrl(MODAL_MODE.SELECT_CATEGORY, {
            callTimelineMode,
          })}
        >
          {t('call_search_screen.call_category')}
        </Link>

        <Link
          to={generatePageModalUrl(MODAL_MODE.SELECT_CALL_SETTINGS, {
            callTimelineMode,
          })}
        >
          {t('call_search_screen.detail_settings.title')}
        </Link>
      </footer>
    </div>
  )
}
export default FilterCallCategory
